export default __webpack_public_path__ + "static/Tino-d2d4721590921def92d9114952dcb5d9.jpg";